import(/* webpackChunkName: "mainStyle" */ 'scss/main.scss')

switch (document.body.getAttribute('site-theme')) {
  case 'builder_new':
    import(/* webpackChunkName: "InterTacticBuilder" */ 'assets/fonts/intern-tactic-builder/InterTacticBuilder.scss')
    import(/* webpackChunkName: "builderNew" */ 'scss/theme-set/builder_new.scss')
    break
  case 'default':
    import(/* webpackChunkName: "defaultTheme" */ 'scss/theme-set/default-theme.scss')
    break
  case 'scitec':
    import(/* webpackChunkName: "scitecShop" */ 'scss/theme-set/scitecshop.scss')
    break
  case 'protein_buzz':
    import(/* webpackChunkName: "proteinBuzz" */ 'scss/theme-set/protein_buzz.scss')
    break
  case 'vitaminshop':
    import(/* webpackChunkName: "vitaminShop" */ 'scss/theme-set/vitaminshop.scss')
    break
  case 'biotech_usa':
    import(/* webpackChunkName: "biotechUsa" */ 'scss/theme-set/biotech_usa.scss')
    break
}

// JavaScript
import(/* webpackChunkName: "airbrake" */ 'js/components/airbrake.js')
import(/* webpackChunkName: "googleAnalytics" */ 'js/components/google-analytics.js')
import(/* webpackChunkName: "global" */ 'js/components/global.js')

// vue-hoz tartozo js importálása
import(/* webpackChunkName: "vue" */ 'js/vue.js')
